const REF_KEY = "fc_ref";
const DEVICE_KEY = "fc_device";
const TTL = 30 * 86400000;

export const captureRef = () => {
  try {
    const code = new URLSearchParams(window.location.search).get("ref");
    if (code && /^[a-z0-9_]{3,30}$/i.test(code)) localStorage.setItem(REF_KEY, JSON.stringify({ code: code.toLowerCase(), exp: Date.now() + TTL }));
  } catch { /* storage unavailable */ }
};

export const getRef = () => {
  try {
    const v = JSON.parse(localStorage.getItem(REF_KEY) || "null");
    return v && v.exp > Date.now() ? v.code : null;
  } catch { return null; }
};

export const deviceId = () => {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) { id = (crypto.randomUUID?.() || `${Date.now()}${Math.random()}`).replace(/-/g, "").slice(0, 32); localStorage.setItem(DEVICE_KEY, id); }
    return id;
  } catch { return null; }
};

export const signupExtras = () => ({ ref: getRef(), device_id: deviceId() });

export const refLink = (code) => `${window.location.origin}/?ref=${encodeURIComponent(code)}`;
